<template>
  <div v-if="visible" class="overlay" @click.self="$emit('close')">
    <div class="modal">
      <div class="modal-top">
        <div class="success-icon">
          <svg width="28" height="28" viewBox="0 0 16 16" fill="currentColor">
            <path d="M13.485 1.929a.75.75 0 0 1 0 1.06l-7.778 7.778a.75.75 0 0 1-1.06 0L1.515 6.636a.75.75 0 1 1 1.06-1.06l2.657 2.657 7.248-7.248a.75.75 0 0 1 1.06 0z"/>
          </svg>
        </div>
        <h3>Binding Successful!</h3>
        <p>
          Your App has been linked to the {{ platformLabel }} store. You can now open the {{ platformLabel }}
          plugin settings to verify the configuration.
        </p>
      </div>

      <div class="modal-body">
        <div class="info-card">
          <div class="info-row">
            <span class="info-label">App Name</span>
            <span class="info-value">{{ appName || '—' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">App ID</span>
            <span class="info-value mono">{{ appId || '—' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ platformLabel }} Store Name</span>
            <span class="info-value">{{ storeName || '—' }}</span>
          </div>
        </div>
      </div>

      <div class="modal-foot">
        <button type="button" class="btn-green" @click="$emit('open-settings')">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <path d="M6.22 3.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L9.94 8 6.22 4.28a.75.75 0 0 1 0-1.06z"/>
          </svg>
          Open {{ platformLabel }} App Settings
        </button>
        <button type="button" class="btn-ghost" @click="$emit('close')">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShoplazzaBindingSuccessModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    appName: {
      type: String,
      default: '',
    },
    appId: {
      type: String,
      default: '',
    },
    storeName: {
      type: String,
      default: '',
    },
    platformLabel: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

.overlay {
  position: fixed;
  inset: 0;
  z-index: 510;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(3px);
  overflow: auto;
}

.modal {
  position: relative;
  width: 100%;
  max-width: 448px;
  margin: auto;
  overflow: hidden;
  border-radius: 16px;
  background: $white;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.18);
  animation: modalIn 0.2s ease;
  flex-shrink: 0;
}

@keyframes modalIn {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(8px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.modal-top {
  padding: 32px 24px 24px;
  text-align: center;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);

  h3 {
    margin: 0 0 4px;
    font-size: 20px;
    font-weight: 700;
    color: $ink;
  }

  p {
    margin: 0;
    font-size: 14px;
    line-height: 1.6;
    color: $ink-3;
  }
}

.success-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 16px;
  border-radius: 50%;
  background: linear-gradient(135deg, $green, $green-dark);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(34, 197, 94, 0.35);
}

.modal-body {
  padding: 16px 24px;
}

.info-card {
  border: 1px solid $border-light;
  border-radius: 12px;
  overflow: hidden;
  background: rgba(249, 250, 251, 0.6);
}

.info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 16px;
  border-bottom: 1px solid $border-light;

  &:last-child {
    border-bottom: none;
  }
}

.info-label {
  font-size: 12px;
  font-weight: 500;
  color: $ink-4;
}

.info-value {
  font-size: 14px;
  font-weight: 600;
  color: $ink-2;
  text-align: right;

  &.mono {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 12px;
  }
}

.modal-foot {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 24px 24px;
}

.btn-green {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 40px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, $green, $green-dark);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;

  &:hover {
    opacity: 0.92;
  }
}

.btn-ghost {
  width: 100%;
  height: 40px;
  border: 1px solid $border;
  border-radius: 8px;
  background: $white;
  color: $ink-3;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;

  &:hover {
    color: $ink;
    border-color: $ink-3;
  }
}
</style>
